<template>
  <div style="height:100%">
    <BaseContainer style="height:100%">
      <el-card class="box-card" style="height: 100%;overflow:auto" shadow="always">
        <el-tabs v-model="activeName">
          <!-- 首图 -->
          <el-tab-pane label="首图" name="tab1">
            <div>
              <el-upload ref="fileUpload1" action="#" list-type="picture-card" :auto-upload="false" :limit="1"
                :on-change="handleChange1" :file-list="FileList.f1">
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{file}">
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                  <span class="el-upload-list__item-actions">
                    <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleDownload(file)">
                      <i class="el-icon-download"></i>
                    </span>
                    <span v-if="!disabled" class="el-upload-list__item-delete"
                      @click="handleRemove(file, 'fileUpload1')">
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
            </div>
          </el-tab-pane>
          <!-- 最新资讯 -->
          <el-tab-pane :label="$t('login.new_infomation')" name="tab2">
            <div>
              <div class="ml-1 mt-2">
                <strong>图片1:</strong>
                <div>
                  <el-upload ref="fileUpload2" action="#" list-type="picture-card" :auto-upload="false" :limit="1"
                    :on-change="handleChange2" :file-list="FileList.f2">
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{file}">
                      <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                      <span class="el-upload-list__item-actions">
                        <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                          <i class="el-icon-zoom-in"></i>
                        </span>
                        <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleDownload(file)">
                          <i class="el-icon-download"></i>
                        </span>
                        <span v-if="!disabled" class="el-upload-list__item-delete"
                          @click="handleRemove(file, 'fileUpload2')">
                          <i class="el-icon-delete"></i>
                        </span>
                      </span>
                    </div>
                  </el-upload>
                </div>
                <strong>标题1:</strong>
                <el-input :rows="2" type="textarea" v-model="articleData.B01.title">
                </el-input>
                <el-button type="text" size="medium" icon="el-icon-edit"
                  @click="contentEditor(articleData.B01)"><strong>内容1</strong></el-button>
                <!-- <strong>内容1:</strong>
                <el-input :rows="3" type="textarea" v-model="articleData.B01.content">
                </el-input> -->
              </div>
              <el-divider></el-divider>
              <div class="ml-1 mt-2">
                <strong>图片2:</strong>
                <div>
                  <el-upload ref="fileUpload3" action="#" list-type="picture-card" :auto-upload="false" :limit="1"
                    :on-change="handleChange3" :file-list="FileList.f3">
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{file}">
                      <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                      <span class="el-upload-list__item-actions">
                        <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                          <i class="el-icon-zoom-in"></i>
                        </span>
                        <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleDownload(file)">
                          <i class="el-icon-download"></i>
                        </span>
                        <span v-if="!disabled" class="el-upload-list__item-delete"
                          @click="handleRemove(file, 'fileUpload3')">
                          <i class="el-icon-delete"></i>
                        </span>
                      </span>
                    </div>
                  </el-upload>
                </div>
                <strong>标题2:</strong>
                <el-input :rows="2" type="textarea" v-model="articleData.B02.title">
                </el-input>
                <el-button type="text" size="medium" icon="el-icon-edit"
                  @click="contentEditor(articleData.B02)"><strong>内容2</strong></el-button>
                <!-- <strong>内容2:</strong>
                <el-input :rows="3" type="textarea" v-model="articleData.B02.content">
                </el-input> -->
              </div>
              <el-divider></el-divider>
              <div class="ml-1 mt-2">
                <strong>图片3:</strong>
                <div>
                  <el-upload ref="fileUpload4" action="#" list-type="picture-card" :auto-upload="false" :limit="1"
                    :on-change="handleChange4" :file-list="FileList.f4">
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{file}">
                      <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                      <span class="el-upload-list__item-actions">
                        <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                          <i class="el-icon-zoom-in"></i>
                        </span>
                        <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleDownload(file)">
                          <i class="el-icon-download"></i>
                        </span>
                        <span v-if="!disabled" class="el-upload-list__item-delete"
                          @click="handleRemove(file, 'fileUpload4')">
                          <i class="el-icon-delete"></i>
                        </span>
                      </span>
                    </div>
                  </el-upload>
                </div>
                <strong>标题3:</strong>
                <el-input :rows="2" type="textarea" v-model="articleData.B03.title">
                </el-input>
                <el-button type="text" size="medium" icon="el-icon-edit"
                  @click="contentEditor(articleData.B03)"><strong>内容3</strong></el-button>
                <!-- <strong>内容3:</strong>
                <el-input :rows="3" type="textarea" v-model="articleData.B03.content">
                </el-input> -->
              </div>
            </div>
          </el-tab-pane>
          <!-- 最新公告 -->
          <el-tab-pane :label="$t('login.new_notice')" name="tab3">
            <div>
              <el-card :body-style="{ padding: '8px' }">
                <div slot="header" class="clearfix">
                  <span>{{ $t("login.new_notice") }}</span>
                  <el-button style="float: right; padding: 3px 0" type="text" @click="AddNewNotice">新增</el-button>
                </div>
                <el-row class="px-1 py-1  mt-2 " style="border: 1px solid #C0C4CC;"
                  v-for="(item, index) in articleData.R01" :key="index">
                  <el-col :span="23">
                    <strong style="display: block;">时间:</strong>
                    <el-date-picker v-model="item.timestamp" type="date" placeholder="日期">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="1" class="text-right"><el-button icon="el-icon-delete" circle
                      @click="RemoveNewNotice(item)"></el-button></el-col>
                  <el-col :span="24"><strong>内容:</strong>
                    <el-input :rows="3" type="textarea" v-model="item.content">
                    </el-input>
                  </el-col>
                </el-row>
              </el-card>
            </div>
          </el-tab-pane>
          <!-- 公司动态 -->
          <el-tab-pane :label="$t('login.company_dynamic')" name="tab4">
            <div>
              <el-card :body-style="{ padding: '8px' }">
                <div slot="header" class="clearfix">
                  <span>{{ $t("login.company_dynamic") }}</span>
                  <el-button style="float: right; padding: 3px 0" type="text" @click="AddCompanyDynamic">新增</el-button>
                </div>
                <el-row class="px-1 py-1  mt-2 " style="border: 1px solid #C0C4CC;"
                  v-for="(item, index) in articleData.R02" :key="index">
                  <el-col :span="23">
                    <strong style="display: block;">时间:</strong>
                    <el-date-picker v-model="item.timestamp" type="date" placeholder="日期">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="1" class="text-right"><el-button icon="el-icon-delete" circle
                      @click="RemoveCompanyDynamic(item)"></el-button></el-col>
                  <el-col :span="24"><strong>内容:</strong>
                    <el-input :rows="3" type="textarea" v-model="item.content">
                    </el-input>
                  </el-col>
                </el-row>
              </el-card>
            </div>
          </el-tab-pane>
          <!-- 快速链接 -->
          <el-tab-pane :label="$t('login.quick_links')" name="tab5">
            <div>
              <el-row class="px-1 py-1  mt-2 " style="border: 1px solid #C0C4CC;"
                v-for="(item, index) in articleData.quick_links" :key="index">
                <el-col :span="24">
                  <strong style="display: block;">名称:</strong>
                  <el-input v-model="item.label" placeholder="" type="text"></el-input>
                </el-col>
                <el-col :span="24"><strong>链接:</strong>
                  <el-input :rows="3" type="textarea" v-model="item.url">
                  </el-input>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>
        <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="saveData"
          :label="$t('common.save')" class="mt-2">
          &nbsp;{{ $t('common.save') }}</QueryButton>
      </el-card>
    </BaseContainer>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
    <el-dialog :title="'内容编辑'" :visible.sync="dialogEditor" :top="'5vh'" :width="'75%'">
      <Toolbar :editor="editorRef" :defaultConfig="toolbarConfig" mode="default"
        style="border-bottom: 1px solid #ccc" />
      <Editor :defaultConfig="editorConfig" mode="default" v-model="valueHtml" class="nb-auto-fill"
        style="height:100%;overflow: auto;" ref="editor" @onCreated="handleCreated" @onChange="handleChange"
        @onDestroyed="handleDestroyed" @onFocus="handleFocus" @onBlur="handleBlur" />
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogEditor = false">取 消</el-button>
        <el-button type="primary" @click="customAlert">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import '@wangeditor/editor/dist/css/style.css'
// -- import * as _ from "lodash-es"
import * as FileUploadController from "../../controllers/FileUploadController"
import * as SystemSettingController from "../../controllers/system/SystemSettingController"
import BaseContainer from "../components/BaseContainer"
import QueryButton from "../components/base/QueryButton"
import TestQueryPanel from "../components/base/TestQueryPanel"

export default {
  components: {
    BaseContainer,
    TestQueryPanel,
    QueryButton,
    Editor,
    Toolbar
  },
  data() {
    return {
      profit_id: "",
      base_url: "https://" + apiConfig.host + '/files',
      methods: SystemSettingController.methods,
      articleData: {
        img: {
          idx: "",
          category: "",
          code: "",
          fileName: "",
          url: ""
        },
        B01: {
          img: {},
          title: "",
          content: ""
        },
        B02: {
          img: {},
          title: "",
          content: ""
        },
        B03: {
          img: {},
          title: "",
          content: ""
        },
        R01: [],
        R02: [],
        quick_links: []
      },
      dialogImageUrl: '',
      dialogVisible: false,
      dialogEditor: false,
      disabled: false,
      activeName: "tab1",
      FileList: {
        f1: [],
        f2: [],
        f3: [],
        f4: [],
      },
      editorRef: null,
      toolbarConfig: {
        excludeKeys: [
          'group-video'
        ]
      },
      valueHtml: "",
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            base64LimitSize: 999999 * 1024 // 将图片保存为base64格式,再通过upload方法上传到服务器
          },
        },
      },
      editorObj: null
    }
  },
  watch: {},
  created() {
    this.GetData()
  },

  // 组件销毁时，也及时销毁编辑器，重要！
  beforeDestroy() {
    const editor = this.editorRef
    if (editor === null) return
    editor.destroy()
  },
  methods: {
    //数据检测
    async saveData(cb) {
      for (var i in this.FileList) {
        if (this.FileList[i].length > 0) {
          let _articleData = {}
          switch (i) {
            case "f1": _articleData = this.articleData; break
            case "f2": _articleData = this.articleData.B01; break
            case "f3": _articleData = this.articleData.B02; break
            case "f4": _articleData = this.articleData.B03; break
          }
          await this.uploadFile(this.FileList[i][0], _articleData)
        }
      }
      let _params = {}
      _params.setting_value = JSON.stringify(this.articleData)
      _params.code = "dashboard_setting"
      _params.id = this.profit_id
      let result = await this.methods.SaveData(_params)
      if (result) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        this.profit_id = result[0][0].id
        cb(true)
      } else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "info")
        cb(false)
      }
    },
    async GetData() {
      let result = await this.methods.GetData({ code: { "=": "dashboard_setting" } })
      if (result[0].length < 1) {
        return
      } else {
        this.profit_id = result[0][0].id
        this.articleData = result[0][0].setting_value ? JSON.parse(result[0][0].setting_value) : {}
        if (this.articleData.img.idx)
          this.FileList.f1.push(this.articleData.img)
        if (this.articleData.B01.img.idx)
          this.FileList.f2.push(this.articleData.B01.img)
        if (this.articleData.B02.img.idx)
          this.FileList.f3.push(this.articleData.B02.img)
        if (this.articleData.B03.img.idx)
          this.FileList.f4.push(this.articleData.B03.img)
      }
    },
    AddNewNotice() {
      this.articleData.R01.unshift({
        timestamp: new Date(),
        content: ""
      })
      this.articleData.R01 = _.orderBy(this.articleData.R01, ["timestamp"], ["desc"])
      for (var i = 0; i < this.articleData.R01.length; i++) {
        if (i == 0)
          this.articleData.R01[i]["color"] = '#0bbd87'
        else {
          this.articleData.R01[i]["size"] = 'large'
          this.articleData.R01[i]["type"] = 'primary'
          this.articleData.R01[i]["icon"] = 'el-icon-more'
        }
      }
    },
    RemoveNewNotice(item) {
      this.articleData.R01 = _.remove(this.articleData.R01, (t) => { return item._id != t._id })
    },
    AddCompanyDynamic() {
      this.articleData.R02.unshift({
        timestamp: new Date(),
        content: ""
      })
      this.articleData.R02 = _.orderBy(this.articleData.R02, ["timestamp"], ["desc"])
      for (var i = 0; i < this.articleData.R02.length; i++) {
        if (i == 0)
          this.articleData.R02[i]["color"] = '#0bbd87'
        else {
          this.articleData.R02[i]["size"] = 'large'
          this.articleData.R02[i]["type"] = 'primary'
          this.articleData.R02[i]["icon"] = 'el-icon-more'
        }
      }
      console.log(this.articleData.R02)
    },
    RemoveCompanyDynamic(item) {
      this.articleData.R02 = _.remove(this.articleData.R02, (t) => { return item._id != t._id })
    },
    //#region 图片上传
    async handleRemove(file, ref_code) {
      let ask = await this.msgModal(this.$t("notify.is_continue"))
      if (!ask) return
      let p = { category: "Dashboard", code: "img", idx: file.idx, fileName: file.fileName }
      await FileUploadController.methods.uploadDelete(p)
      switch (ref_code) {
        case "fileUpload1": this.articleData.img = {}; break
        case "fileUpload2": this.articleData.B01.img = {}; break
        case "fileUpload3": this.articleData.B02.img = {}; break
        case "fileUpload4": this.articleData.B03.img = {}; break
      }
      let _params = {}
      _params.setting_value = JSON.stringify(this.articleData)
      _params.code = "dashboard_setting"
      _params.id = this.profit_id
      let result = await this.methods.SaveData(_params)
      if (result)
        this.$refs[ref_code].clearFiles()
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    async handleDownload(file) {
      console.log(file)
    },
    handleChange1(file, fileList) {
      this.FileList.f1 = fileList
    },
    handleChange2(file, fileList) {
      this.FileList.f2 = fileList
    },
    handleChange3(file, fileList) {
      this.FileList.f3 = fileList
    },
    handleChange4(file, fileList) {
      this.FileList.f4 = fileList
    },
    async uploadFile(file, data) {
      let p = { category: "Dashboard", code: "img", files: file.raw }
      let frt = await FileUploadController.methods.uploadFiles(p)
      if (frt && frt.length > 0) {
        let img_list = frt[0].queryString.split("&")
        let m = {}
        _.forEach(img_list, (t) => {
          let items = t.split("=")
          m[items[0]] = items[1]
        })
        let prefx_name = m.fileName.substring(0, m.fileName.lastIndexOf(".") + 1)
        let last_name = m.fileName.substring(m.fileName.lastIndexOf(".") + 1)
        m["url"] = `${this.base_url}/${m.category}/${m.code}/${prefx_name}${m.idx}.${last_name}`
        data.img = m
      }
    },
    //#endregion
    //#region 内容编辑
    contentEditor(data) {
      this.editorObj = data
      this.valueHtml = data.content
      this.dialogEditor = true
    },
    // 编辑器回调函数
    handleCreated(editor) {
      this.editorRef = editor // 记录 editor 实例，重要！
    },
    customAlert() {
      console.log(this.valueHtml)
      this.editorObj.content = this.valueHtml
      this.dialogEditor = false
    },
    handleChange(editor) {
      // console.log('change:', editor.getHtml());
    },
    handleDestroyed(editor) {
      //console.log('destroyed', editor);
    },
    handleFocus(editor) {
      //console.log('focus', editor);
    },
    handleBlur(editor) {
      // console.log('blur', editor);
    },
    //#endregion
  },
}
</script>
<style></style>
